var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchActive = function SvgSearchActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.233 16.53a8.25 8.25 0 1 1 1.296-1.296L19.9 18.6a.917.917 0 0 1-1.297 1.296l-3.37-3.369ZM3.667 10.082a6.417 6.417 0 1 1 11.038 4.451.919.919 0 0 0-.17.171 6.417 6.417 0 0 1-10.868-4.622Zm11 0a4.583 4.583 0 1 1-9.167 0 4.583 4.583 0 0 1 9.167 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearchActive;